import { Table } from "antd";
import { IBillStatement } from "eligibility/models";

const fmt = (v: number | null) => (v == null ? "—" : v.toLocaleString());

const columns = [
  { title: "Statement Date", dataIndex: "statementDate", render: (v: string) => v || "—" },
  { title: "Account #", dataIndex: "accountNumber", render: (v: string) => v || "—" },
  { title: "Billing Period", dataIndex: "billingPeriod", render: (v: string) => v || "—" },
  { title: "Billed Load (kW/kVA)", dataIndex: "billedLoadKw", render: fmt },
  { title: "Metered kW", dataIndex: "meteredKw", render: fmt },
  { title: "Therms", dataIndex: "therms", render: fmt },
  { title: "Notes", dataIndex: "notes", render: (v: string) => v || "" },
];

export const StatementTable = ({ statements }: { statements: IBillStatement[] }) => (
  <Table<IBillStatement>
    rowKey="id"
    dataSource={statements}
    columns={columns}
    pagination={false}
    size="small"
    // Highlight rows carrying an extraction note so they get verified.
    rowClassName={(r) => (r.notes ? "eligibility-row-flagged" : "")}
  />
);
